import { ChangeDetectionStrategy, Component, EventEmitter, Output, computed, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ButtonMode, ButtonTheme, IconPosition } from '@fcom/ui-components';
import { UpsellPromotion } from '@fcom/booking/modules/ticket-selection/interfaces/cabin-class-selection-fare-family.interface';

import { shouldDisplayBenefit } from '../../../utils/benefit.utils';

@Component({
  selector: 'fin-upsell-promotion',
  templateUrl: './upsell-promotion.component.html',
  styleUrls: ['./upsell-promotion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UpsellPromotionComponent {
  readonly upsellOffer = input<UpsellPromotion>();

  @Output()
  confirmUpsell: EventEmitter<void> = new EventEmitter();

  public readonly ButtonTheme = ButtonTheme;
  public readonly SvgLibraryIcon = SvgLibraryIcon;
  public readonly IconPosition = IconPosition;
  public readonly ButtonMode = ButtonMode;

  readonly currentBenefits = computed(
    () =>
      this.upsellOffer()?.currentOffer.translatedBenefitRows.filter((benefit) => shouldDisplayBenefit(benefit)) ?? []
  );

  readonly newBenefits = computed(
    () => this.upsellOffer()?.upsellOffer.translatedBenefitRows.filter((benefit) => shouldDisplayBenefit(benefit)) ?? []
  );
}
